import { connect } from 'react-redux';

import MobileNav from './mobile_nav.jsx';

import {
  getIsInPageSearchEnabled
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  handleMenuItemPostClickBehavior
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import { 
  executeMatchedRouteIfSameHashOnMenuItemClick
} from 'zoomforth_codesbane_viewer/lib/backbone_history_utils.js';

import {
  setIsInPageSearchDisplayed
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import { getIsUsingLegacyHeader } from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state) => {
  const isInPageSearchEnabled = getIsInPageSearchEnabled(state);
  const isUsingLegacyHeader = getIsUsingLegacyHeader(state);
  return {
    isUsingLegacyHeader,
    isInPageSearchEnabled
  };
};

const mapDispatchToProps = (dispatch, { currentSubpage }) => ({


  onMobileMenuItemClick: (menuItem)=>{
    dispatch(handleMenuItemPostClickBehavior(menuItem, currentSubpage, { shouldScrollTopForPageChange:true }));
  },

  onMobileSubmenuItemClick: (submenuItem)=>{
    getTracker().handleNavMenuItemClick(submenuItem);
    executeMatchedRouteIfSameHashOnMenuItemClick(submenuItem);
  },

  onSearchInPageClick: ()=> {
    dispatch(setIsInPageSearchDisplayed(true));
  }

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileNav);
